var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"app",attrs:{"id":"app"}},[_c('PageMain',{attrs:{"scrollPos":_vm.scrollPos,"scroll":_vm.scroll,"windowresizing":_vm.windowresizing}}),_c('Footerr',{ref:"footer",staticClass:"footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }